// extracted by mini-css-extract-plugin
module.exports = {"Screenshot":"Screenshot_Screenshot__12FRX","overlay":"Screenshot_overlay__3fGD9","text":"Screenshot_text__1eXdB","description":"Screenshot_description__nCvuh"};